import { Form, Select, Spin, Empty } from 'antd'
import { LoadingOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { useCallback, useEffect, useState } from 'react'
import { useAxios } from '../../../hooks/useAxios'

interface IProps {
    id?: string | any
    label: string
    name: string
    varToShow?: any
    required?: boolean
    requiredMessage?: string
    className?: string | any
    placeholder?: string
    endpoint?: string
    data?: any
    value?: any
    disabled?: boolean
    groupBy?: string
    params?: any
    tooltipTitle?: any
    showTooltips?: any
    method?: any
    handleSuccess?: (data: any) => void
}

export const CustomSelect = ({ ...props }: IProps) => {
    const {
        id,
        label,
        name,
        required = false,
        disabled = false,
        requiredMessage = 'Obligatorio',
        placeholder = 'Seleccione una opción',
        endpoint,
        value,
        params = {},
        handleSuccess,
        data,
        className,
        varToShow,
        tooltipTitle,
        method,
        showTooltips = false,
    } = props
    const { get } = useAxios()
    const [selectedValue, setSelectedValue] = useState<any>(null)
    const [dataResponse, setDataResponse] = useState<any>([])
    const [localEndpoint, setLocalEndpoint] = useState<any>('')
    const [spinner, setSpinner] = useState<boolean>(false)

    const antIcon = (
        <LoadingOutlined style={{ fontSize: 24, color: '#13023E' }} spin />
    )

    useEffect(() => {
        if (value && dataResponse.length) {
            setSelectedValue(value)
        }

        return () => {}
    }, [dataResponse])

    useEffect(() => {
        if (selectedValue !== value && dataResponse.length) {
            setSelectedValue(value)
        }
        if (endpoint !== localEndpoint) {
            setLocalEndpoint(endpoint)
            getData()
        }
        if (data) {
            getData()
        }
        return () => {}
    }, [value, endpoint, data])

    const getData = () => {
        setSpinner(true)
        if (endpoint) {
            setDataResponse([])
            if (method) {
                method(endpoint, {}, success, error, always)
            } else get(endpoint, {}, success, error, always)
        } else if (data) {
            let result = data.reduce(
                (acc: any, item: any) => [
                    ...acc,
                    {
                        label:
                            item[varToShow] ||
                            item.label ||
                            item.name ||
                            item.full_name ||
                            item.alias_name,
                        value: item.id || item.value,
                    },
                ],
                [],
            )
            setDataResponse(result)
            setSpinner(false)
        }
    }

    const success = useCallback((response: any) => {
        let dataResponse: any = []
        if (handleSuccess) {
            dataResponse = handleSuccess(response.data.data)
        } else {
            let data: any = response.data.data
            let result = data
            dataResponse = result.reduce(
                (acc: any, item: any) => [
                    ...acc,
                    {
                        label:
                            item[varToShow] ||
                            item.label ||
                            item.name ||
                            item.full_name ||
                            item.alias_name,
                        value: item.id || item.value,
                    },
                ],
                [],
            )
        }
        setDataResponse(dataResponse)
        setSpinner(false)
    }, [])

    const error = (errors: any) => {
        setSpinner(false)
        console.log(errors)
    }

    const always = () => {
        setSpinner(false)
    }

    const configTooltips = showTooltips
        ? {
              title: tooltipTitle,
              icon: <InfoCircleOutlined />,
          }
        : false
    return (
        <Form.Item
            id={id}
            name={name}
            label={label}
            className={className}
            valuePropName='option'
            rules={[
                {
                    required: required,
                    message: requiredMessage,
                },
            ]}
            tooltip={configTooltips}>
            <Select
                disabled={disabled}
                showSearch
                value={selectedValue}
                onFocus={getData}
                notFoundContent={
                    spinner ? (
                        <Spin
                            className='spin-select'
                            indicator={antIcon}
                            size='small'
                        />
                    ) : (
                        <Empty description={false} />
                    )
                }
                placeholder='Seleccione'
                allowClear
                options={dataResponse}
                filterOption={(input: any, option: any) =>
                    option.label?.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                }></Select>
        </Form.Item>
    )
}
